import React, { Component } from 'react';

class CarouselLeftArrow extends Component {
  getButtonStyles(disabled) {
    return {
      border: 0,
      background: 'transparent',
      padding: 10,
      outline: 0,
      opacity: disabled ? 0.3 : 1,
      cursor: 'pointer'
    };
  }

  getImageStyles() {
    return {
      height: '28px'
    };
  }

  render() {
    const self = this;
    return (
      <button
        style={this.getButtonStyles(self.props.currentSlide === 0 && !self.props.wrapAround)}
        onClick={self.props.previousSlide}
      >
        <input
          type="image"
          src="static/left_arrow.png"
          alt="PREV"
          style={this.getImageStyles()}
        />
      </button>
    );
  }
}

export default CarouselLeftArrow;



// WEBPACK FOOTER //
// ./src/components/CarouselLeftArrow/CarouselLeftArrow.js